var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-tabs"},[_c('div',{staticClass:"container"},[_c('Tabs')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }